import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

// Kullanıcının pinlediği kısayol anahtarlarını getirir (sıralı string[])
export const useUserShortcutsQuery = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/userShortcuts/list';
  const fetchData = async (): Promise<string[]> => {
    const res = await axios.get<{ shortcuts: string[] }>(requestUrl, {
      params: { company_id: user?.company_id, user_id: user?.id },
    });
    return res?.data?.shortcuts || [];
  };
  return useQuery(['user-shortcuts', user?.id], fetchData, {
    enabled: !!user?.id && !!user?.company_id,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    onError,
  });
};

// Kullanıcının kısayol anahtar listesini topluca kaydeder
export const useSaveUserShortcuts = (onSuccess?: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/userShortcuts/save';
  return useMutation(
    (shortcuts: string[]) => {
      return axios.post(requestUrl, {
        company_id: user?.company_id,
        user_id: user?.id,
        shortcuts,
      });
    },
    { onSuccess, onError },
  );
};
